/** @file VIEWPORT_GROUPS: the overlay camera's rendering groups, each drawn over the one before. */

/**
 * The overlay camera draws the ground grid and axes in group 0, then `puppet` (1: the quad showing the pixel-art
 * target), `marks` (2: bones, then joints) and `gizmo` (3); groups 1..3 clear depth first (`createViewportScene`), so
 * the grid never cuts the puppet and nothing hides a joint or a handle.
 */
export const VIEWPORT_GROUPS = { puppet: 1, marks: 2, gizmo: 3 } as const;
